<template>
    <div class="legacy">
        <div class="video-view text-white">
            <div class="container-fluid__with-padding-x video-view__head">
                <div class="close_button-container">
                    <div class="close_button flex justify-end" v-on:click="close">
                    <span>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="black" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 0L23 21L21 23L0 2L2 0Z"/>
                            <path d="M0 21L21 0L23 2L2 23L0 21Z"/>
                        </svg>
                    </span>
                    </div>
                </div>
            </div>

            <video-embed v-if="video" :src="video.url" :params="{autoplay: 1}" css="embed-responsive-21by9" class="video-view__container"/>

            <div class="container-fluid__with-padding-x video-view__footer">
                <div class="text-right" v-on:click="toggleInfo">
                    <span v-if="!show" class="pointer">{{ $t('video.see-more') }}</span>
                    <span v-else class="pointer">{{ $t('video.close') }}</span>
                </div>
                <div class="video-view__info" v-if="show">
                    <div class="row">
                        <div class="col-md mb-3">
                            <div class="separator margin_bottom_60">{{ $t('video.details') }}</div>
                            <div v-if="video.title">
                                <div class="video-view__label">{{ $t('video.title') }}</div>
                                <div class="margin_bottom_30">{{ video.title}}</div>
                            </div>

                            <div v-if="video.events.length > 0">
                                <div class="video-view__label">{{ video.events.length > 1 ? $t('lowercase.events') : $t('lowercase.event') }}</div>
                                <template  v-for="event in video.events">
                                    <b-link style="color: white"
                                            :key="event.id"
                                            :to="{ name: 'event.view', params: { id: event.id, slug: event.slug } }">
                                        {{ event.name }}
                                    </b-link>
                                </template>

                            </div>
                        </div>
                        <div class="col-md mb-3">
                            <div class="separator margin_bottom_60">{{ $t('video.description') }}</div>
                            <div v-html="video.description"></div>
                        </div>
                        <div class="col-md-5 mb-3">
                            <div class="separator margin_bottom_60">{{ $t('video.linked') }}</div>
                            <div v-if="video.related_videos">
                                <div class="row justify-content-center">
                                    <div class="col-6 mb-3" v-for="related in video.related_videos">
                                        <video-link :video="related"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import VideoLink from "../components/legacy/Search/VideoLink";
import DarkMode from "../mixins/dark-mode";

export default {
    name: "VideoView",
    components: {
        VideoLink
    },
    mixins: [DarkMode],
    props: {
        id: {
            required: true
        }
    },
    created() {
        // load the video media with its related data
        this.get(this.id)
    },
    data: () => {
        return {
            setDarkMode: true,
            show: false
        }
    },
    methods: {
        ...mapActions('video', [
            'get'
        ]),

        close() {
            //this.$emit('close')
            this.$router.back()

        },
        toggleInfo() {
            this.show = !this.show
        },
        emitSelected(id) {
            //this.$emit('selected', id)
        }
    },
    computed: {
        ...mapState('video', [
            'video'
        ])
    },
}
</script>

<style scoped>

</style>
